import { getSettingsDomain } from "../settings/scope";
import { GET_CRE_LINKS } from "./query";

// Map an entity ref collection (the shape panels already carry) to the link
// graph's target type.
const REF_COLLECTION_TO_TARGET_TYPE = {
  propertyAssets: "propertyAsset",
  contacts: "contact",
  deals: "deal",
};

export const targetTypeForRefCollection = (refCollection) =>
  REF_COLLECTION_TO_TARGET_TYPE[refCollection] || "";

// Domain is implicit from the signed-in user (super-admin switcher included);
// it is never a caller choice.
export const apiGetCreLinks = async ({ targetType, targetId, sourceType }) => {
  const domain = getSettingsDomain();
  if (!domain || !targetType || !targetId) return [];
  const client = (await import("../index")).default;
  const input = { domain, targetType, targetId };
  if (sourceType) input.sourceType = sourceType;
  const result = await client.query({
    query: GET_CRE_LINKS,
    variables: { input },
    fetchPolicy: "no-cache",
  });
  return result?.data?.creLinks?.links || [];
};
